(function() {
  function initFlippingAutonomousAnt() {
    const ant = document.getElementById("shopifyAntPet");
    if (!ant || ant.hasAttribute("data-autonomous-ready")) return;
    ant.setAttribute("data-autonomous-ready", "true");

    let currentX = Math.random() * (window.innerWidth - 60) + 30;
    let currentY = Math.random() * (window.innerHeight - 60) + 30;
    let targetX = currentX;
    let targetY = currentY;
    let stepCount = 0;
    
    // Inverted baseline scale defaults to fix backwards crawling orientations
    let flipScaleX = 1;

    const crawlSpeed = 0.65; 
    let isPaused = false;
    let pauseTimer = 0;

    function pickNewDestination() {
      const padding = 40;
      targetX = Math.random() * (window.innerWidth - padding * 2) + padding;
      targetY = Math.random() * (window.innerHeight - padding * 2) + padding;
      
      // REVERSED DIRECTION CONFIGURATION:
      // Maps the horizontal mirroring logic directly to match your system's native emoji graphics profile
      if (targetX < currentX) {
        flipScaleX = 1;  // Faces Left when traveling Left
      } else {
        flipScaleX = -1; // Faces Right when traveling Right
      }
    }

    pickNewDestination();

    function wanderLoop() {
      if (isPaused) {
        pauseTimer--;
        if (pauseTimer <= 0) {
          isPaused = false;
          pickNewDestination();
        }
        requestAnimationFrame(wanderLoop);
        return;
      }

      const dx = targetX - currentX;
      const dy = targetY - currentY;
      const distance = Math.hypot(dx, dy);

      if (distance < 15) {
        isPaused = true;
        pauseTimer = Math.floor(Math.random() * 120) + 30; 
        requestAnimationFrame(wanderLoop);
        return;
      }

      stepCount += 0.2;

      const jitter = Math.sin(stepCount) * 0.4;
      const normalizedDx = dx / distance;
      const normalizedDy = dy / distance;

      const perpX = -normalizedDy * jitter;
      const perpY = normalizedDx * jitter;

      currentX += (normalizedDx * crawlSpeed) + perpX;
      currentY += (normalizedDy * crawlSpeed) + perpY;

      currentX = Math.max(10, Math.min(window.innerWidth - 40, currentX));
      currentY = Math.max(10, Math.min(window.innerHeight - 40, currentY));

      ant.style.transform = "translate3d(" + currentX.toFixed(2) + "px, " + currentY.toFixed(2) + "px, 0px) scaleX(" + flipScaleX + ")";

      requestAnimationFrame(wanderLoop);
    }

    requestAnimationFrame(wanderLoop);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initFlippingAutonomousAnt);
  } else {
    initFlippingAutonomousAnt();
  }
  document.addEventListener("shopify:section:load", initFlippingAutonomousAnt);
})();
